<template>
  <!--
    水煮酸汤系列主题专区
   -->
  <div>
    <!--第一系列img-->
    <img class="img-first" src="https://cdn-product-prod.cotticoffee.com/app-themeArea/activity_shuizhu.png" alt="" />
    <div class="red-bg">
      <!--第一系列左右排列楼层区域-->
      <div class="float-box">
        <div
          v-for="(item, index) in firstSeries.firstFlow"
          :key="item.itemNo"
          class="float-item"
          @click="goDetail(item)"
        >
          <img class="float-img" :src="item.litimgUrl" alt="">
          <div
            class="info-wrap light-red-bg"
            :class="[(index % 2) === 0 ? 'f-left' : 'f-right']"
          >
            <div class="name">{{ item.itemShowName }}</div>
            <div class="origin-price">
              原价￥{{ item.firstSku.standardPriceStr ? item.firstSku.standardPriceStr : '--' }}
            </div>
            <div class="price-wrap">
              <img
                v-if="item.skuAllSaleOut > 0"
                class="cart-img"
                :src="require('@/assets/themezone/cart_enable.png')"
                @click.stop="handleAddCart(item)"
              />
              <div class="price">
                ￥{{ item.firstSku.lowestPriceStr ? item.firstSku.lowestPriceStr : '--' }}
              </div>
            </div>
          </div>
          <!--售罄-->
          <img
            v-if="item.skuAllSaleOut === 0"
            :src="require('@/assets/themezone/sellout.png')"
            class="sellout-img"
            :class="[(index % 2) === 0 ? 'sell-right' : 'sell-left']"
          />
        </div>
      </div>
      <!--第一系列两列楼层区域-->
      <div class="item-box">
        <div
          v-for="item in firstSeries.secondFlow"
          :key="item.itemShowName"
          class="item item-light-red-bg"
          @click="goDetail(item)"
        >
          <img class="item-img" :src="item.litimgUrl" alt="">
          <img
            v-if="item.skuAllSaleOut > 0"
            class="cart-img"
            :src="require('@/assets/themezone/cart_enable.png')"
            @click.stop="handleAddCart(item)"
          />
          <div class="price-box">
            <div class="name">{{ item.itemShowName }}</div>
            <div class="price-wrap">
              <div class="origin-price">
                原价￥{{ item.firstSku.standardPriceStr ? item.firstSku.standardPriceStr : '--' }}
              </div>
              <div class="price">
                ￥{{ item.firstSku.lowestPriceStr ? item.firstSku.lowestPriceStr : '--' }}
              </div>
            </div>
          </div>
          <!--售罄-->
          <img
            v-if="item.skuAllSaleOut === 0"
            :src="require('@/assets/themezone/sellout.png')"
            class="sellout-img"
          />
        </div>
      </div>
    </div>
    <!--第二系列img-->
    <img class="img-second" src="https://cdn-product-prod.cotticoffee.com/app-themeArea/activity_suantang.png" alt="" />
    <div class="green-bg">
      <!--第二系列左右排列楼层区域-->
      <div class="float-box">
        <div
          v-for="(item, index) in secondSeries.firstFlow"
          :key="item.itemShowName"
          class="float-item"
          @click="goDetail(item)"
        >
          <img class="float-img" :src="item.litimgUrl" alt="">
          <div
            class="info-wrap light-green-bg"
            :class="[(index % 2) === 0 ? 'f-left' : 'f-right']"
          >
            <div class="name">{{ item.itemShowName }}</div>
            <div class="origin-price">
              原价￥{{ item.firstSku.standardPriceStr ? item.firstSku.standardPriceStr : '--' }}
            </div>
            <div class="price-wrap">
              <img
                v-if="item.skuAllSaleOut > 0"
                class="cart-img"
                :src="require('@/assets/themezone/cart_enable.png')"
                @click.stop="handleAddCart(item)"
              />
              <div class="price">
                ￥{{ item.firstSku.lowestPriceStr ? item.firstSku.lowestPriceStr : '--' }}
              </div>
            </div>
          </div>
          <!--售罄-->
          <img
            v-if="item.skuAllSaleOut === 0"
            :src="require('@/assets/themezone/sellout.png')"
            class="sellout-img"
            :class="[(index % 2) === 0 ? 'sell-right' : 'sell-left']"
          />
        </div>
      </div>
      <!--第二系列两列楼层区域-->
      <div class="item-box">
        <div
          v-for="item in secondSeries.secondFlow"
          :key="item.itemShowName"
          class="item item-light-green-bg"
          @click="goDetail(item)"
        >
          <img class="item-img" :src="item.litimgUrl" alt="">
          <img
            v-if="item.skuAllSaleOut > 0"
            class="cart-img"
            :src="require('@/assets/themezone/cart_enable.png')"
            @click.stop="handleAddCart(item)"
          />
          <div class="price-box">
            <div class="name">{{ item.itemShowName }}</div>
            <div class="price-wrap">
              <div class="origin-price">
                原价￥{{ item.firstSku.standardPriceStr ? item.firstSku.standardPriceStr : '--' }}
              </div>
              <div class="price">
                ￥{{ item.firstSku.lowestPriceStr ? item.firstSku.lowestPriceStr : '--' }}
              </div>
            </div>
          </div>
          <!--售罄-->
          <img
            v-if="item.skuAllSaleOut === 0"
            :src="require('@/assets/themezone/sellout.png')"
            class="sellout-img"
          />
        </div>
      </div>
    </div>
    <!--底部-->
    <img class="footer-img" src="https://cdn-product-prod.cotticoffee.com/app-themeArea/activity_bottom.png" alt="">
    <!--浮动按钮 只在浏览器或微信浏览器中显示-->
    <template v-if="isInBrowser">
      <div class="green-bg" :style="{
        'height': isInstallShow ? '100px' : '50px'
      }">
        <!--空标签为了撑高底部区域-->
      </div>
      <div class="float-btn">
        <openButton
          type="default"
          buttonTxt="打开舌尖英雄APP"
          @isInstallShow="watchIsInstallShow"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { isWeixin, isAndroid, isIOS } from '@/utils'
import wx from 'weixin-js-sdk'
import openButton from "@/components/openButton";

export default {
  name: "poach",
  components: {
    openButton
  },
  data() {
    return {
      // 门店编号
      shopMdCode: '',
      // 取餐方式
      takeFoodMode: '',
      // 判断是否是微信平台
      isWeixinPlatform: false,
      // 判断是否是小程序中
      isInMiniApp: false,
      // 判断是否在浏览器中
      isInBrowser: false,
      // 判断是否有"已安装，立即打开"按钮
      isInstallShow: false,
      // 第一系列
      firstSeries: {
        firstFlow: [], // 楼层1商品列表
        secondFlow: [] // 楼层2商品列表
      },
      // 第二系列
      secondSeries: {
        firstFlow: [], // 楼层1商品列表
        secondFlow: [] // 楼层2商品列表
      },
      // 主题专区配置
      configData: {},
      // 配置中心数据
      configCenterData: {}
    }
  },
  created() {
    // 处理url参数重复
    let shopcode = this.$route.query.shopMdCode
    let taketype = this.$route.query.takeFoodMode || '1'
    if (Array.isArray(shopcode)) {
      this.shopMdCode = shopcode[0]
    } else {
      this.shopMdCode = shopcode
    }
    if (Array.isArray(taketype)) {
      this.takeFoodMode = taketype[0]
    } else {
      this.takeFoodMode = taketype
    }
    this.getConfigCenterData()
    this.getConfigData()
    this.getListData()
  },
  async mounted() {
    this.isWeixinPlatform = isWeixin()
    this.isInMiniApp = await this.isMiniProgram()
    this.isInBrowser = this.isBrowser()
    window.getShareConfig = this.getShareConfig

    console.log('----环境----')
    console.log('isWeixin: ', isWeixin())
    console.log('isInApp: ', this.isInApp())
    console.log('isMiniProgram: ', this.isInMiniApp)
    console.log('isBrowser: ', this.isInBrowser)
  },
  methods: {
    // 监听openButton子组件是否显示已安装按钮
    watchIsInstallShow(val) {
      this.isInstallShow = val
    },
    // 判断是否在APP中打开
    isInApp() {
      // 根据 window.HandleShare 判断是否在APP中访问
      return !!window.HandleShare
    },
    // 判断是否在微信浏览器或普通浏览器中打开
    isBrowser() {
      return !this.isInApp() && !this.isInMiniApp
    },
    // 判断是否是微信浏览器还是小程序环境
    isMiniProgram() {
      // wx.miniProgram.getEnv是异步，所以封装在Promise中
      return new Promise(resolve => {
        if (this.isWeixinPlatform) {
          return wx.miniProgram.getEnv(res => {
            if (res.miniprogram) {
              resolve(true)
            } else {
              resolve(false)
            }
          })
        }
        resolve(false)
      })
    },
    // App分享
    getShareConfig() {
      let shareObj = {}
      // 判断配置中心是否打开了"小程序分享"开关
      if (this.configCenterData.miniProgramSharingSwitch === 'true') {
        let h5ShareUrl = `${this.configData.wxminiCard.h5ShareUrl}&shopMdCode=${this.shopMdCode}&takeFoodMode=${this.takeFoodMode}`
        let arr = h5ShareUrl.split('url=')
        let basePath = arr[0] || ''
        let encodeurl = arr[1] ? encodeURIComponent(arr[1]) : ''
        let shareUrl = `${basePath}url=${encodeurl}`
        shareObj = {
          shareTitle: this.configData.wxminiCard.title,
          shareContent: this.configData.wxminiCard.context,
          litimgUrl: this.configData.wxminiCard.thumbnail,
          shareUrl: shareUrl,
          path: shareUrl
        }
      } else {
        shareObj = {
          shareTitle: this.configData.h5Card.title,
          shareContent: this.configData.h5Card.context,
          litimgUrl: this.configData.h5Card.thumbnail,
          shareUrl: `${this.configData.h5Card.h5ShareUrl}&shopMdCode=${this.shopMdCode}&takeFoodMode=${this.takeFoodMode}`,
          path: '/'
        }
      }
      console.log('APP分享参数: ', JSON.stringify(shareObj))
      return JSON.stringify(shareObj)
    },
    // 获取主题专区配置信息
    getConfigData() {
      this.$api.themezone.themezone.getConfig().then(res => {
        if (res.code === 200) {
          if (res.busCode === '1') {
            let data = res.data || {}
            this.configData = data
          } else {
            this.$toast({
              message: res.busMessage
            })
          }
        } else {
          this.$toast({
            message: res.message
          })
        }
      }).catch(err => {
        this.$toast({
          message: err.message
        })
      })
    },
    // 获取配置中心配置信息
    getConfigCenterData() {
      this.$api.themezone.common.getConfigCenter().then(res => {
        if (res.code === 200) {
          if (res.busCode === '1') {
            let data = res.data || null
            this.configCenterData = data
          } else {
            this.$toast({
              message: res.busMessage
            })
          }
        } else {
          this.$toast({
            message: res.message
          })
        }
      }).catch(err => {
        this.$toast({
          message: err.message
        })
      })
    },
    // 获取页面列表数据
    getListData() {
      console.log('$route.query: ', this.$route.query)
      let params = {
        shopMdCode: this.shopMdCode,
        takeFoodMode: this.takeFoodMode
      }
      this.$api.themezone.themezone.getItems(params).then(res => {
        if (res.code === 200) {
          if (res.busCode === '1') {
            let data = res.data || {}
            let firstSeriesData = data?.firstSerias || {}
            this.firstSeries.firstFlow = firstSeriesData?.firstFlow?.items || []
            this.firstSeries.secondFlow = firstSeriesData?.secondFlow?.items || []
            let secondSeriesData = data?.secondSerias || {}
            this.secondSeries.firstFlow = secondSeriesData?.firstFlow?.items || []
            this.secondSeries.secondFlow = secondSeriesData?.secondFlow?.items || []
          } else {
            this.$toast({
              message: res.busMessage
            })
          }
        } else {
          this.$toast({
            message: res.message
          })
        }
      }).catch(err => {
        this.$toast({
          message: err.message
        })
      })
    },
    // 判断运行环境
    handleEnv(item) {
      // 在微信浏览器或普通浏览器打开跳转下载页
      if (this.isInBrowser) {
        if (isAndroid()) {
          window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.abite.predishes.prehome'
        }
        if (isIOS()) {
          window.location.href = 'https://www.abite.com/app/'
        }
        return false;
      }
      // 当小程序访问时，跳转商品详情页
      if (this.isInMiniApp) {
        wx.miniProgram.navigateTo({
          url: `/sub-menu/product/product?itemNo=${item.itemNo}&shopMdCode=${this.shopMdCode}&takeFoodMode=${this.takeFoodMode}`
        })
        return false;
      }
      return true
    },
    // 加购
    handleAddCart(item) {
      // 判断是否在浏览器或小程序中
      if (!this.handleEnv(item)) {
        return;
      }
      // 判断是否售罄
      if (!item.skuAllSaleOut) {
        return;
      }
      let isSkus = item.skuNum && item.skuNum > 1
      let itemNo = item.itemNo
      let skuNo = item.firstSku ? item.firstSku.skuNo : ''
      // APP中
      if (this.isInApp()) {
        let obj = {
          itemNo,
          skuNo,
          pageTitle: '活动页面',
          isSkus,
          isActivitySku: false
        }
        let params = JSON.stringify(obj)
        console.log('params typeof: ', typeof params)
        console.log('加购--postMessage数据: ', params)
        AddToCart.postMessage(params);
        return;
      }
    },
    // 跳转详情页
    goDetail(item) {
      // 判断是否在浏览器或小程序中
      if (!this.handleEnv(item)) {
        return;
      }
      let itemNo = item.itemNo
      let skuNo = item.firstSku ? item.firstSku.skuNo : ''
      // APP中
      if (this.isInApp()) {
        let obj = { itemNo, skuNo }
        let params = JSON.stringify(obj)
        console.log('params typeof: ', typeof params)
        console.log('跳详情--postMessage数据: ', params)
        GoProductDetail.postMessage(params);
        return;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/font/topTaurusTi/topTaurus.css";
@import "~@/font/aliPuHuiTi/aliPuHuiTiRegular.css";

img {
  display: block;
}

// 第一系列图
.img-first {
  width: 100%;
  height: 2337px;
}
// 左右浮动楼层
.float-box {
  padding: 43px 0 65px;
  margin-top: -1px;
  .float-item {
    position: relative;
    // 最后一项不设置下边距
    &:not(:last-child) {
      margin-bottom: 50px;
    }
    .float-img {
      width: 100%;
      height: 524px;
    }
    .info-wrap {
      padding: 17px 25px 17px 29px;
      position: absolute;
      bottom: 0px;
      min-height: 150px;
      &.light-red-bg {
        background: rgba(100, 0, 0, 0.7);
      }
      &.light-green-bg {
        background: rgba(0, 0, 0, 0.35);
      }
      .name {
        font-size: 42px;
        color: #FFFFFF;
        font-family: "Top Taurus";
      }
      .origin-price {
        color: #FFFFFF;
        font-size: 22px;
        font-family: "Ali PuHuiTi";
        text-decoration: line-through;
        margin-top: 10px;
      }
      .price-wrap {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        .cart-img {
          width: 59px;
          height: 59px;
          margin-top: 9px;
          z-index: 10;
        }
        .price {
          margin-left: 20px;
          font-size: 76px;
          color: #FF6A39;
          font-family: "Top Taurus";
          height: 60px;
          line-height: 64px;
        }
      }
      &.f-left {
        left: 154px;
      }
      &.f-right {
        left: 261px;
      }
    }
    .sellout-img {
      position: absolute;
      top: 153px;
      width: 145px;
      height: 145px;
      &.sell-left {
        left: 116px;
      }
      &.sell-right {
        right: 116px;
      }
    }
  }
}
// 两列楼层
.item-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 18px 30px;
  box-sizing: border-box;
  margin-top: -1px;
  .item {
    position: relative;
    width: 49%;
    height: 471px;
    border-radius: 16px;
    &.item-light-red-bg {
      background: rgba(101, 0, 0, 0.8);
    }
    &.item-light-green-bg {
      background: rgba(0, 0, 0, 0.35);
    }
    // 列表前两项不设置上边距
    &:not(:nth-child(-n+2)) {
      margin-top: 20px;
    }
    .item-img {
      width: 100%;
      height: 344px;
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
    }
    .cart-img {
      position: absolute;
      bottom: 16px;
      left: 16px;
      width: 59px;
      height: 59px;
      z-index: 10;
    }
    .price-box {
      position: absolute;
      bottom: 41px;
      right: 18px;
      transform: rotate(-8.4deg); // 旋转
      .name {
        font-size: 42px;
        color: #FFFFFF;
        font-family: "Top Taurus";
        transform: skewX(-16.6deg); // 倾斜
        text-align: right;
      }
      .price-wrap {
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;
        margin-left: 10px;
        .origin-price {
          color: #FFFFFF;
          font-size: 19px;
          font-family: "Ali PuHuiTi";
          text-decoration: line-through;
          margin-top: 6px;
          transform: skewX(-16.6deg);
        }
        .price {
          font-size: 59px;
          color: #FF6A39;
          font-family: "Top Taurus";
          transform: skewX(-16.6deg);
        }
      }
    }
    .sellout-img {
      position: absolute;
      top: 92px;
      right: 20px;
      width: 145px;
      height: 145px;
    }
  }
}

// 第二系列图
.img-second {
  width: 100%;
  height: 1098px;
}
.red-bg {
  background: #9b3434;
}
.green-bg {
  background: #207758;
}

// 底部图
.footer-img {
  width: 100%;
  height: 248px;
}

// 打开APP
.float-btn {
  position: fixed;
  left: 50%;
  bottom: 10px;
  transform: translate(-50%);
  z-index: 20;
}
</style>